let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dU1ZU")).then(() => parcelRequire('bM8uo'));